// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES5 which can result in a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_INDEX_OF = "indexOf"; // Count: 9
export var _DYN_LENGTH = "length"; // Count: 6
export var _DYN_TRACK_PAGE_ACTION = "trackPageAction"; // Count: 4
export var _DYN_USE_DEFAULT_CONTENT_0 = "useDefaultContentNameOrId"; // Count: 5
export var _DYN_CAPTURE_ALL_META_DAT1 = "captureAllMetaDataContent"; // Count: 3
export var _DYN_META_DATA_PREFIX = "metaDataPrefix"; // Count: 3
export var _DYN_PARENT_DATA_TAG = "parentDataTag"; // Count: 4
export var _DYN_DEFAULT_RIGHT_CLICK_2 = "defaultRightClickBhvr"; // Count: 2
export var _DYN_TAG_NAME = "tagName"; // Count: 4
export var _DYN_TO_UPPER_CASE = "toUpperCase"; // Count: 5
export var _DYN_PAGE_NAME = "pageName"; // Count: 8
export var _DYN_CORE_DATA = "coreData"; // Count: 4
export var _DYN_REQUEST_URI = "requestUri"; // Count: 3
export var _DYN_GET_ATTRIBUTE = "getAttribute"; // Count: 6
export var _DYN_PARENT_NODE = "parentNode"; // Count: 3
export var _DYN_CUSTOM_DATA_PREFIX = "customDataPrefix"; // Count: 3
export var _DYN_NAME = "name"; // Count: 8
export var _DYN_DATA = "data"; // Count: 15
export var _DYN_PAGE_TYPE = "pageType"; // Count: 6
export var _DYN_PROPERTIES = "properties"; // Count: 4
export var _DYN_ACTION_TYPE = "actionType"; // Count: 9
export var _DYN_BEHAVIOR = "behavior"; // Count: 7
export var _DYN_CONTENT = "content"; // Count: 4
export var _DYN_SET_COMMON_PROPERTIE3 = "setCommonProperties"; // Count: 2
export var _DYN__GET_VALID_BEHAVIOR = "_getValidBehavior"; // Count: 3
export var _DYN_CONTENT_NAME = "contentName"; // Count: 9
export var _DYN__TRACE_LOGGER = "_traceLogger"; // Count: 3
export var _DYN_CLICK_COORDINATE_X = "clickCoordinateX"; // Count: 3
export var _DYN_CLICK_COORDINATE_Y = "clickCoordinateY"; // Count: 3
export var _DYN__CONFIG = "_config"; // Count: 9
export var _DYN_DATA_TAGS = "dataTags"; // Count: 6
export var _DYN__PAGE_TAGS = "_pageTags"; // Count: 6
export var _DYN__PAGE_TAGS_CALLBACK = "_pageTagsCallback"; // Count: 3
export var _DYN__META_TAGS = "_metaTags"; // Count: 6
export var _DYN__PAGE_TYPE_META_TAG = "_pageTypeMetaTag"; // Count: 3
export var _DYN__BEHAVIOR_META_TAG = "_behaviorMetaTag"; // Count: 3
export var _DYN_PARENT_ELEMENT = "parentElement"; // Count: 3
export var _DYN_ATTRIBUTES = "attributes"; // Count: 4
//# sourceMappingURL=__DynamicConstants.js.map